import script from "./AllocationsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AllocationsPage.vue?vue&type=script&lang=ts&setup=true"

import "./AllocationsPage.vue?vue&type=style&index=0&id=c2707b82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2707b82"]])

export default __exports__